require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-golf-sponsorship.json") })
        }
      }, "path---articles-tags-golf-sponsorship");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-golf-sponsorship!./.cache/json/articles-tags-golf-sponsorship.json
// module id = 1828
// module chunks = 231608221292675